var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "container" },
    [
      _c("div", { staticClass: "row justify-content-md-center" }, [
        _c(
          "div",
          { staticClass: "col-sm-12 d-flex flex-wrap justify-content-center" },
          _vm._l(_vm.items, function (row, index) {
            return _c(
              "div",
              {
                key: index,
                staticClass: "card m-2 shadow-sm w-full",
                staticStyle: { "max-width": "80vh" },
              },
              [
                _c(
                  "div",
                  {
                    staticClass:
                      "card-body d-flex flex-column justify-content-between",
                  },
                  [
                    _c("div", { staticClass: "flex-column" }, [
                      _c("div", { staticClass: "card-badge" }, [
                        _c("span", { staticClass: "badge badge-success" }, [
                          _vm._v(
                            "\n                " +
                              _vm._s(row.status) +
                              "\n              "
                          ),
                        ]),
                      ]),
                      _vm._v(" "),
                      _c("div", { staticClass: "text-secondary" }, [
                        _c("i", {
                          staticClass: "icon md-calendar-note",
                          attrs: { "aria-hidden": "true" },
                        }),
                        _vm._v(" "),
                        _c("span", [
                          _vm._v(
                            _vm._s(row.date_start) +
                              " - " +
                              _vm._s(row.date_end)
                          ),
                        ]),
                      ]),
                    ]),
                    _vm._v(" "),
                    _c("h5", { staticClass: "mb-auto" }, [
                      _c("span", [
                        _vm._v(_vm._s(index + 1) + ". " + _vm._s(row.name)),
                      ]),
                    ]),
                    _vm._v(" "),
                    _c("section", { staticClass: "mt-2 mb-4" }, [
                      _c("span", [_vm._v("Прогресс по курсу:")]),
                      _vm._v(" "),
                      _c("div", { staticClass: "d-flex align-items-center" }, [
                        _c("progress", {
                          staticClass: "w-full",
                          attrs: { max: "100" },
                          domProps: { value: row.progress_slides },
                        }),
                        _vm._v(" "),
                        _c(
                          "span",
                          {
                            staticClass: "ml-1",
                            staticStyle: { width: "3rem" },
                          },
                          [_vm._v(_vm._s(row.progress_slides) + "%")]
                        ),
                      ]),
                      _vm._v(" "),
                      row.has_test
                        ? _c("span", [_vm._v("Тестирование:")])
                        : _vm._e(),
                      _vm._v(" "),
                      row.has_test
                        ? _c(
                            "div",
                            { staticClass: "d-flex align-items-center" },
                            [
                              _c("progress", {
                                staticClass: "w-full",
                                attrs: { max: "100" },
                                domProps: { value: row.progress_tests },
                              }),
                              _vm._v(" "),
                              _c(
                                "span",
                                {
                                  staticClass: "ml-1",
                                  staticStyle: { width: "3rem" },
                                },
                                [_vm._v(_vm._s(row.progress_tests) + "%")]
                              ),
                            ]
                          )
                        : _vm._e(),
                    ]),
                    _vm._v(" "),
                    _c(
                      "div",
                      { staticClass: "d-flex row justify-content-around" },
                      [
                        _c(
                          "a",
                          {
                            staticClass: "btn btn-primary mt-1",
                            attrs: {
                              href: row.button_course_status
                                ? row.course_url
                                : "",
                              disabled: !row.button_course_status,
                            },
                          },
                          [_c("b", [_vm._v(_vm._s(row.button_course_text))])]
                        ),
                        _vm._v(" "),
                        _c(
                          "a",
                          {
                            staticClass: "btn btn-primary mt-1",
                            attrs: {
                              href:
                                row.button_exam_status &&
                                !row.practice_block &&
                                !row.remote_practice_block
                                  ? row.exam_url
                                  : "",
                              disabled: !row.button_exam_status,
                            },
                            on: {
                              click: function ($event) {
                                return _vm.examLinkHandler(row, $event)
                              },
                            },
                          },
                          [_c("b", [_vm._v(_vm._s(row.button_exam_text))])]
                        ),
                      ]
                    ),
                  ]
                ),
              ]
            )
          }),
          0
        ),
      ]),
      _vm._v(" "),
      _vm.showPracticeModal
        ? _c("practice-required-modal", {
            attrs: { "practice-sheet-url": _vm.practiceSheetUrl },
            on: {
              close: function ($event) {
                _vm.showPracticeModal = false
              },
            },
          })
        : _vm._e(),
      _vm._v(" "),
      _vm.showRemotePracticeModal
        ? _c("remote-practice-modal", {
            attrs: {
              "sheet-url": _vm.remotePractice.sheetUrl,
              "sign-url": _vm.remotePractice.signUrl,
              "upload-url": _vm.remotePractice.uploadUrl,
              "pep-allowed": _vm.remotePractice.pepAllowed,
            },
            on: {
              passed: _vm.onRemotePracticePassed,
              close: function ($event) {
                _vm.showRemotePracticeModal = false
              },
            },
          })
        : _vm._e(),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }